import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import "./Assets/css/default.min.css";
import { Helmet } from "react-helmet";
//main page preview image
import SiteImage0 from "./Assets/Images/home/ministryHistory/0.jpg";

//components
import Header from "./Components/headerComponent/header";
import Footer from "./Components/footerComponent/footer";
import Bulletin from "./Components/bulletinComponent/bulletin";
import Home from "./Components/pages/home";
import AboutUs from "./Components/pages/aboutUs";
import OurMinistries from "./Components/pages/ourMinistries";
import GetInvolved from "./Components/pages/getInvolved";
import Report from "./Components/pages/report";
import Story from "./Components/pages/story";

//images
//import FireBackground from './Assets/images/fireLogo2.jpg';
class App extends Component {
  constructor(props) {
    super(props);
    //---deprecated, height removed this.state = {language:"eng", height: 0};
    this.state = { language: "eng", orientation: "landscape", scrollPos: -10 };
    this.UpdateLanguage = this.UpdateLanguage.bind(this);
    // --deprecated this.UpdateHeight = this.UpdateHeight.bind(this)
  }
  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    //window.addEventListener("scroll", this.trackScrollPos);
    this.UpdateScrollPos(0);
  }
  render() {
    return (
      <div className="App" style={{ position: "relative", backgroundColor: "#1a1a1a", overflow: "hidden" }}>
        <Helmet>
          <title>CAC MCRD</title>
          <meta property="og:url" content={"https://cacmcrd.netlify.app/"} />
          <meta property="og:type" content={"organization information"} />
          <meta property="og:title" content={"CAC MCRD"} />
          <meta property="og:description" content={"Chinese Anual Conference(CAC) Methodist Crisis Relief and Development Malaysia, CAC MCRD Official Website.马来西亚基督教卫理公会华人年议会救援赈灾事工官方网站."} />
        </Helmet>
        <Router>
          {/*<div className="background-image">
              <img style={{opacity:"0.3", width:"50%", height:"50%"}} src={FireBackground}/>
          </div>*/}
          <body style={{ overflow: "hidden" }}>
            <Route exact path="/" render={() => <Home language={this.state.language} orientation={this.state.orientation} updateScrollPos={this.UpdateScrollPos} scrollPos={this.state.scrollPos} />} />
            <Route exact path="/AboutUs" render={() => <AboutUs language={this.state.language} orientation={this.state.orientation} scrollPos={this.state.scrollPos} />} />
            <Route exact path="/Ministries" render={() => <OurMinistries language={this.state.language} orientation={this.state.orientation} updateScrollPos={this.UpdateScrollPos} scrollPos={this.state.scrollPos} />} />
            <Route exact path="/GetInvolved" render={() => <GetInvolved language={this.state.language} orientation={this.state.orientation} scrollPos={this.state.scrollPos} />} />
            {/*reports path*/}
            <Route exact path="/Ministries/Reports/0" render={() => <Report report={0} />} />
            <Route exact path="/Ministries/Reports/1" render={() => <Report report={1} />} />
            <Route exact path="/Ministries/Reports/2" render={() => <Report report={2} />} />
            <Route exact path="/Ministries/Reports/3" render={() => <Report report={3} />} />
            {/*stories path*/}
            <Route exact path="/Ministries/Stories/0" render={() => <Story story={0} />} />
            <Route exact path="/Ministries/Stories/1" render={() => <Story story={1} />} />
          </body>
          {/* ---deprecated remove unused func updateHeight <Header updateLanguage={this.UpdateLanguage} updateHeight={this.UpdateHeight} />*/}
          {/* ---deprecated <div
            className="mask"
            style={{
              position: "absolute",
              left: "0px",
              top: "0px",
              width: "100%",
              height: "100%",
              backgroundColor: "#000000",
              opacity: "6%",
            }}
          />*/}
          {/*<Bulletin language={this.state.language} updateScrollPos={this.UpdateScrollPos} orientation={this.state.orientation}/>*/}
          <Footer updateScrollPos={this.UpdateScrollPos} />
          <Header updateLanguage={this.UpdateLanguage} updateScrollPos={this.UpdateScrollPos} orientation={this.state.orientation} />
        </Router>
      </div>
    );
  }
  resize() {
    if (window.innerWidth > window.innerHeight) this.setState({ orientation: "landscape" });
    else this.setState({ orientation: "portrait" });
  }
  UpdateScrollPos = (e) => {
    window.history.scrollRestoration = "manual";
    const scrollHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
    if (document.body.scrollHeight >= e) window.scrollTo(0, e);
    else window.setTimeout(() => this.UpdateScrollPos(e), 100);
  };
  trackScrollPos = (e) => {
    console.log("track:" + window.scrollY);
  };
  /*EnforceScrollPos =(e) => {
    const treshold = 100;
    if(Math.abs(window.scrollY - this.state.previousScrollPos) > treshold)//not user scroll, but is auto scroll
    {
      window.setTimeout(()=>{
        window.scrollTo(0, e, "smooth");
        this.setState({reload: false});
        window.removeEventListener("scroll", this.EnforceScrollPos);
      }, 250);
    } else
      this.setState({previousScrollPos: window.scrollY});
      window.setTimeout(()=>{
        window.removeEventListener("scroll", this.EnforceScrollPos);
      }, 500); //after 1 second remove listener suspect bouncing occurs at 0
  }*/
  UpdateLanguage = (e) => {
    this.setState({ language: e });
  };
  /* ---deprecated UpdateHeight = (e) => {
    this.setState({height: e})
  }*/
}
export default App;
